import { ExternalLink, Phone, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PayPalDirectDeposit = ({ config }) => (
  <div data-testid="deposit-paypal-direct">
    <div data-testid="deposit-amount" className="text-4xl font-bold text-white">${config.amount}</div>
    <p data-testid="deposit-currency" className="text-xs text-[#A89F94] mt-2 mb-6">
      {config.currency} booking deposit · Applied to your final invoice
    </p>
    <p data-testid="deposit-paypal-recipient" className="text-sm text-white font-semibold mb-4 break-all">
      @{config.recipient}
    </p>
    <Button asChild className="h-auto w-full whitespace-normal gap-2 py-3.5 px-4 bg-[#F7C500] hover:bg-[#FFE066] text-black font-bold transition-colors">
      <a href={config.payment_url} target="_blank" rel="noopener noreferrer" data-testid="deposit-paypal-link">
        Pay ${config.amount} with PayPal <ExternalLink className="w-4 h-4 shrink-0" aria-hidden="true" />
      </a>
    </Button>
    <p data-testid="deposit-manual-confirmation-notice" className="text-sm text-[#C7BFB6] leading-relaxed mt-5">
      Payment is completed on PayPal. Select Goods and Services where available.
      Your visit is confirmed after Will verifies your deposit.
    </p>
    <a href="tel:+12258927777" data-testid="deposit-direct-confirm-call" className="inline-flex items-center justify-center gap-2 text-sm text-white underline underline-offset-4 mt-4 hover:text-[#FFE066] transition-colors">
      <Phone className="w-4 h-4 shrink-0" aria-hidden="true" /> Call Will to confirm receipt
    </a>
    <p data-testid="deposit-payment-provider" className="flex items-center justify-center gap-2 text-xs text-[#8F9BA6] mt-6">
      <ShieldCheck className="w-4 h-4 shrink-0" aria-hidden="true" /> Paid securely on PayPal
    </p>
  </div>
);